/**
 * The days of the week
 */
export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export const DAYS__TO_MASK_MAP: {
    [key: number]: DayOfWeek;
} = {
    // sat|fri|thurs|wed|tues|mon|sun
    1: DayOfWeek.Sunday,
    2: DayOfWeek.Monday,
    4: DayOfWeek.Tuesday,
    8: DayOfWeek.Wednesday,
    16: DayOfWeek.Thursday,
    32: DayOfWeek.Friday,
    64: DayOfWeek.Saturday, // 1000000
};

/**
 * The months
 */
export enum MonthOfYear {
    January = 0,
    February = 1,
    March = 2,
    April = 3,
    May = 4,
    June = 5,
    July = 6,
    August = 7,
    September = 8,
    October = 9,
    November = 10,
    December = 11,
}

/**
 * First week of the year settings types
 */
export enum FirstWeekOfYear {
    FirstDay = 0,
    FirstFullWeek = 1,
    FirstFourDayWeek = 2,
}

/**
 * The supported date range types
 */
export enum DateRangeType {
    Day = 0,
    Week = 1,
    Month = 2,
    WorkWeek = 3,
}
